<template>
  <div>
    <app-cells><h1 class="title">Transactions</h1></app-cells>
    <app-tabs :tabs="tabs_to_show" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'HotelManagementTransactionsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'hotel-management-transactions', label: 'Transactions', roles: ['general_manager'] },
        { name: 'hotel-management-transactions-pos', label: 'POS', roles: ['general_manager'] },
      ],
      tabs_to_show: [],
    }
  },
  created() {
    this.tabsToShow()
  },
  methods: {
    tabsToShow() {
      const tabs = []
      this.tabs.forEach(item => {
        if (!item.roles.length) {
          tabs.push(item)
          return
        }
        item.roles.forEach(role => {
          if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) tabs.push(item)
        })
      })
      this.tabs_to_show = tabs
    },
  }
}
</script>
